import React from "react";
import { Check } from "lucide-react";

interface PricingCardProps {
  name: string;
  price: number;
  requests: number;
  features: string[];
  popular?: boolean;
  currencySymbol: string;
  formattedPrice: string;
  onSelectPlan: () => void;
}

export function PricingCard({
  name,
  price,
  requests,
  features,
  popular,
  currencySymbol,
  formattedPrice,
  onSelectPlan,
}: PricingCardProps) {
  return (
    <div
      className={`relative rounded-xl overflow-hidden ${
        popular
          ? "border-2 border-volt-blue shadow-lg shadow-volt-blue/20"
          : "border border-gray-700"
      }`}
    >
      {popular && (
        <div className="absolute top-0 right-0 bg-volt-blue text-white text-xs font-bold px-3 py-1 rounded-bl-lg">
          MOST POPULAR
        </div>
      )}
      <div className="p-6">
        <h3 className="text-xl font-bold text-white mb-2">{name}</h3>
        <div className="mb-4">
          <span className="text-3xl font-bold text-white">
            {currencySymbol}
            {formattedPrice}
          </span>
          <span className="text-gray-400 ml-1">/month</span>
        </div>
        <p className="text-gray-400 mb-6">
          {requests.toLocaleString()} AI requests per month
        </p>
        <button
          onClick={onSelectPlan}
          className={`w-full py-2 px-4 rounded-lg font-medium transition-colors ${
            popular
              ? "bg-volt-blue text-white hover:bg-volt-blue/90"
              : "bg-white/10 text-white hover:bg-white/20"
          }`}
        >
          {popular ? "Get Started" : "Select Plan"}
        </button>
      </div>
      <div className="bg-white/5 p-6">
        <h4 className="font-medium text-white mb-4">What's included:</h4>
        <ul className="space-y-3">
          {features.map((feature, index) => (
            <li key={index} className="flex items-start">
              <Check className="h-5 w-5 text-volt-blue mr-2 flex-shrink-0 mt-0.5" />
              <span className="text-gray-300">{feature}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
